import TextSubCategoryList from './TextSubCategoryList'

export default TextSubCategoryList
